// extracted by mini-css-extract-plugin
module.exports = {"holder":"BlogPreviewDescriptionStyle-module--holder--1fc16","bold_text":"BlogPreviewDescriptionStyle-module--bold_text--1KoQD"};